import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SEVERITY } from '../../utils/Snackbar';
import { getAuthenticated, getUserData } from '../../utils/LocalStorage';
import { emailEhValido } from '../../utils/Formatters';
import { post, get } from '../../utils/Api';
import { useNavigate, useParams } from "react-router";
import StaticHeader from '../../utils/StaticHeader';
import MailIcon from '@mui/icons-material/Mail';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const TIPO_PAGINA = {
  CADASTRAR_USUARIO: {
    titulo: 'Novo Usuário',
    botao: 'Enviar e-mail',
    explicacao: 'Um link será enviado para o e-mail indicado. A partir deste link o novo usuário poderá acessar o sistema e preencher o nome, a senha, e concluir o cadastro.',
    tipo: 'cadastrar-usuario',
  },
  REDEFINIR_SENHA: {
    titulo: 'Redefinir Senha',
    botao: 'Enviar e-mail',
    explicacao: 'Um link será enviado para seu e-mail. A partir deste link você poderá redefinir sua senha.',
    tipo: 'redefinir-senha',
  },
  REDEFINIR_EMAIL: {
    titulo: 'Redefinir E-Mail',
    botao: 'Enviar e-mail',
    explicacao: 'Um link será enviado para o seu novo e-mail. A partir deste link você confirmará a alteração.',
    tipo: 'redefinir-email',
  },
  REENVIAR_EMAIL: {
    titulo: 'Reenviar E-Mail',
    botao: 'Reenviar e-mail',
    explicacao: 'Um novo e-mail será enviado para este usuário, a partir do qual ele poderá acessar o sistema e concluir seu cadastro. Caso o e-mail não seja encontrado, peça ao usuário que verifique na caixa de spans.',
    tipo: 'reenviar-email',
  },
};

export default function EmailDialog({
  setLoading,
  handleMessage,
  version,
  mainError,
  setError,
  tipoPagina
}) {
  const { uuid } = useParams();

  const navigate = useNavigate();
  const [perfis,setPerfis] = useState([]);
  const [perfilUUID,setPerfilUUID] = useState('');
  const [escritorios,setEscritorios] = useState([]);
  const [usuarioRoot,setUsuarioRoot] = useState(false);
  const [escritorioUUID,setEscritorioUUID] = useState('');
  const [emailReenviar,setEmailReenviar] = useState('');

  const getUsuario = (callback) => {
    getAuthenticated(callback);
  };

  const validarEmail = (email,callback) => {
    const email_valido = emailEhValido(email);

    if (!email_valido) {
      handleMessage('E-mail inválido!',SEVERITY.WARNING.toString(),'',false);
      callback(false,'','');
    } else {

      get(`api/validar-email/${email}`,(json)=>{

        getUsuario((usuario)=>{

          if (TIPO_PAGINA.REDEFINIR_SENHA.tipo === tipoPagina.tipo) {

            if (!json.email_existe) {
              handleMessage('Este e-mail não existe!',SEVERITY.WARNING.toString(),'',false);
              callback(false,json.usuario_uuid,json.escritorio_uuid);
            } else {
              if (json.usuario_existe_inativo) {
                handleMessage('Usuário está inativo!',SEVERITY.WARNING.toString(),'',false);
                callback(false,json.usuario_uuid,json.escritorio_uuid);
              } else {
                setEscritorioUUID(json.escritorio_uuid);
                callback(true,json.usuario_uuid,json.escritorio_uuid);
              }
            }

          } else if (TIPO_PAGINA.REDEFINIR_EMAIL.tipo === tipoPagina.tipo) {

            if (json.email_existe) {
              handleMessage('Este e-mail já existe no sistema!',SEVERITY.WARNING.toString(),'',false);
              callback(false,usuario.usuario_uuid,usuario.escritorio_uuid);
            } else {
              if (json.email === usuario.usuario_email) {
                handleMessage('O e-mail digitado é igual ao atual!',SEVERITY.WARNING.toString(),'',false);
                callback(false,usuario.usuario_uuid,usuario.escritorio_uuid);
              } else {
                callback(true,usuario.usuario_uuid,usuario.escritorio_uuid);
              }
            }

          } else if (TIPO_PAGINA.CADASTRAR_USUARIO.tipo === tipoPagina.tipo) {

            if (json.email === usuario.usuario_email) {
              handleMessage('O e-mail digitado é igual ao seu e-mail!',SEVERITY.WARNING.toString(),'',false);
              callback(false,'novo-usuario','');
            } else {
              if (json.email_existe) {
                handleMessage('Este e-mail já existe no sistema!',SEVERITY.WARNING.toString(),'',false);
                callback(false,'novo-usuario','');
              } else {
                callback(true,'novo-usuario','');
              }
            }

          } else if (TIPO_PAGINA.REENVIAR_EMAIL.tipo === tipoPagina.tipo) {
            callback(true,json.usuario_uuid,json.escritorio_uuid);
          } else {
            handleMessage('Tela inválida!',SEVERITY.WARNING.toString(),'',true);
            callback(false,'');
          }

        });

      },(error,message,severity)=>{
        handleMessage(message,severity,error,true);
        callback(false,'');
      });

    }
  };

  const irParaRaiz = () => {
    navigate(-1);
  };

  const handleChange = (event) => {
    if (mainError) { return; }
    const data = new FormData(event.currentTarget);
    const usuario_email = (TIPO_PAGINA.REENVIAR_EMAIL.tipo === tipoPagina.tipo) ? emailReenviar : data.get('usuario_email');
    const perfil_uuid = perfilUUID;

    setLoading(true);

    validarEmail(usuario_email,(valido,usuario_uuid,escritorio_uuid_retorno)=>{
      if (valido) {

        if (
          (usuario_uuid !== undefined) &&
          (usuario_uuid !== null) &&
          (usuario_uuid != '') &&
          (escritorio_uuid_retorno !== undefined) &&
          (escritorio_uuid_retorno !== null)
        ) {

          let escritorio_uuid = escritorioUUID;
          if (escritorio_uuid_retorno !== '') {
            escritorio_uuid = escritorio_uuid_retorno;
          }

          post(`api/enviar-email/${tipoPagina.tipo}/${usuario_uuid}`,{
            usuario_email: usuario_email,
            perfil_uuid: perfil_uuid,
            escritorio_uuid: escritorio_uuid
          },(json)=>{

            setLoading(false);
            if (json.email_enviado) {

              if (TIPO_PAGINA.CADASTRAR_USUARIO.tipo === tipoPagina.tipo) {
                irParaRaiz();
                handleMessage('E-mail de cadastro enviado com sucesso!',SEVERITY.SUCCESS.toString(),'',false);
              } else if (TIPO_PAGINA.REDEFINIR_SENHA.tipo === tipoPagina.tipo) {
                irParaRaiz();
                handleMessage('E-mail de redefinição de senha enviado!',SEVERITY.SUCCESS.toString(),'',false);
              } else if (TIPO_PAGINA.REDEFINIR_EMAIL.tipo === tipoPagina.tipo) {
                irParaRaiz();
                handleMessage('E-mail de redefinição enviado com sucesso!',SEVERITY.SUCCESS.toString(),'',false);
              } else if (TIPO_PAGINA.REENVIAR_EMAIL.tipo === tipoPagina.tipo) {
                irParaRaiz();
                handleMessage('E-mail de cadastro enviado com sucesso!',SEVERITY.SUCCESS.toString(),'',false);
              } else {
                handleMessage('Operação inválida!',SEVERITY.WARNING.toString(),'',true);
              }
            } else {
              handleMessage('Falha ao enviar o e-mail!',SEVERITY.WARNING.toString(),'',false);
            }

          },(error,message,severity)=>{
            setLoading(false);
            handleMessage(message,severity,error,true);
          });

        } else {
          handleMessage('Código do usuário inválido!',SEVERITY.WARNING.toString(),'',false);
          setLoading(false);
        }

      } else {
        setLoading(false);
      }
    });
  };

  useEffect(()=>{
    setLoading(true);
    getUserData((administrador,root,escritorio_uuid)=>{
      setUsuarioRoot(root);
      setEscritorioUUID(escritorio_uuid);

      get(`api/escritorios`,(jsonEscritorios)=>{
        setEscritorios(jsonEscritorios.escritorios);

        get(`api/perfis`,(jsonPerfis)=>{
          setPerfis(jsonPerfis.perfis);
          setPerfilUUID(jsonPerfis.perfis.find(perfil => perfil.perfil_nome === 'Advogado').perfil_uuid);

          if (TIPO_PAGINA.REENVIAR_EMAIL.tipo === tipoPagina.tipo) {

            if ( (uuid !== undefined) && (uuid !== null) && (uuid !== '') ) {
              get(`api/usuario/${uuid}/email-para-reenviar`,(jsonUsuario)=>{
                if ((jsonUsuario !== undefined) && (jsonUsuario !== null) && jsonUsuario.retorno_valido) {
                  setEmailReenviar(jsonUsuario.usuario_email);
                  setLoading(false);
                } else {
                  handleMessage('Falha ao obter o e-mail do usuário!',SEVERITY.WARNING.toString(),'',false);
                  setLoading(false);
                }
              });
            } else {
              handleMessage('Código do usuário inválido!',SEVERITY.WARNING.toString(),'',false);
              setLoading(false);
            }

          } else {
            setLoading(false);
          }
        },(error,message,severity)=>{
          setLoading(false);
          handleMessage(message,severity,error,true);
        });

      },(error,message,severity)=>{
        setLoading(false);
        handleMessage(message,severity,error,true);
      });

    });

  },[]);

  return (
    <StaticHeader
      version={version}
      setLoading={setLoading}
      handleMessage={handleMessage}
      error={mainError}
      setError={setError}>
      <Dialog
        closeAfterTransition={false}
        open={true}
        onClose={()=>{}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        role="alertdialog"
        component="form"
        onSubmit={(event) => {
          event.preventDefault();
          handleChange(event);
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ backgroundColor: '#1565c0', color: '#fff' }}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', }}>
            <MailIcon sx={{ display: 'flex' }} />
            <Typography component="span" sx={{ color: '#fff', fontSize: 20 }}>
              {tipoPagina.titulo}
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent
          sx={{ width: { xs: 'auto', sm: '400px' } }}>
          <Grid
            container
            spacing={1}
            sx={{
              marginTop: 4,
            }}>

            {
              (TIPO_PAGINA.REDEFINIR_SENHA.tipo !== tipoPagina.tipo) ? (
                <Grid item="true" size={12} sx={{ marginBottom: '4px', }}>
                  <TextField
                    fullWidth
                    required
                    slotProps={{ inputLabel: { shrink: true } }}
                    id="escritorio_uuid"
                    name="escritorio_uuid"
                    label="Escritório"
                    value={escritorioUUID}
                    select
                    onChange={setEscritorioUUID}
                    disabled={!usuarioRoot || (TIPO_PAGINA.REENVIAR_EMAIL.tipo === tipoPagina.tipo)}>
                    {escritorios.map((option) => (
                      <MenuItem key={option.escritorio_uuid} value={option.escritorio_uuid}>
                        {option.escritorio_nome}
                      </MenuItem>
                    ))}
                  </TextField>
              </Grid>
              ) : (<></>)
            }

            <Grid item="true" size={12}>
              <TextField
                fullWidth
                required
                slotProps={{ inputLabel: { shrink: true } }}
                id="usuario_email"
                name="usuario_email"
                label="E-mail"
                disabled={TIPO_PAGINA.REENVIAR_EMAIL.tipo === tipoPagina.tipo}
                defaultValue={emailReenviar}
              />
            </Grid>

            {
              (TIPO_PAGINA.CADASTRAR_USUARIO.tipo === tipoPagina.tipo) ? (
                <Grid item="true" size={12} sx={{ marginTop: '4px', }}>
                  <TextField
                    fullWidth
                    required
                    slotProps={{ inputLabel: { shrink: true } }}
                    id="perfil_uuid"
                    name="perfil_uuid"
                    select
                    label="Perfil do Usuário"
                    value={perfilUUID}
                    onChange={(event)=>{
                      setPerfilUUID(event.target.value);
                    }}
                  >
                    {perfis.map((option) => (
                      <MenuItem key={option.perfil_uuid} value={option.perfil_uuid}>
                        {option.perfil_nome}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              ) : (<></>)
            }

            <Grid
              item="true"
              size={12}>
              <Box
               sx={{
                 backgroundColor: '#f5f5f5',
                 boxSizing: 'border-box',
                 color: 'rgba(0, 0, 0, 0.38)',
                 fontSize: '16px',
                 fontWeight: '400',
                 width: '100%',
                 borderRadius: '4px',
                 display: 'flex',
                 padding: '6px 14px 8px 14px',
                 border: '1px solid #C4C4C4',
               }}>
               {tipoPagina.explicacao}
              </Box>
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            size="large"
            onClick={irParaRaiz}>
            Voltar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="success"
            startIcon={<MailIcon />}
            size="large">
            {tipoPagina.botao}
          </Button>
        </DialogActions>
      </Dialog>
    </StaticHeader>
  );
}
